import { afterNextRender, DestroyRef, Directive, ElementRef, inject, output, OutputEmitterRef } from '@angular/core';

@Directive({
  selector: '[viewportObserver]',
  standalone: true,
})
export class ViewportObserverDirective {
  readonly viewportObserver: OutputEmitterRef<boolean> = output<boolean>();

  private readonly el = inject(ElementRef<HTMLElement>);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    afterNextRender(() => {
      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          this.viewportObserver.emit(entry.isIntersecting);
        }
      });

      observer.observe(this.el.nativeElement as HTMLElement);
      this.destroyRef.onDestroy(() => observer.disconnect());
    });
  }
}
